/**
 * @generated SignedSource<<76407fe05f8f659ccb1b2a7dbf977573>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateSidebar_packageDate$data = {
  readonly end: string;
  readonly package: {
    readonly id: string;
    readonly name: string;
  };
  readonly start: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "PackageDateSidebar_packageDate";
};
export type PackageDateSidebar_packageDate$key = {
  readonly " $data"?: PackageDateSidebar_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateSidebar_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateSidebar_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Package",
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "766d3df22c06c78e1622f9ae23e2710f";

export default node;
